export const LOGGED_OUT_BRAND_PRODUCTS_PAGE_SIZE = 8;
